export default __webpack_public_path__ + "static/media/share.2da07071.jpg";